import * as LAVVAStorage from '../../integrations/lavva/storage';

export const clearStorageData = () => {
  const theme = LAVVAStorage.getItem('theme');
  const deviceId = localStorage.getItem('DEVICE_ID');
  const local = localStorage.getItem('local-app');

  localStorage.clear();
  LAVVAStorage.clear();
  sessionStorage.clear();

  LAVVAStorage.setItem('theme', theme);
  if (deviceId) localStorage.setItem('DEVICE_ID', deviceId);
  if (local) localStorage.setItem('local-app', 'true');
};
